const NavigateToTop = function() {

  let $doc = $(document);
  let $navbar = $doc.find('body >  nav.navbar');
  let $buttonToTop = $doc.find('.nav-top button');

  let isButtonTopAvailable = $buttonToTop.length > 0;

  if( isButtonTopAvailable ) {
    $buttonToTop.on('click', function() {
      $('html, body').animate({ scrollTop: $navbar.offset().top }, 500);
    });
  }
};

const ShowNavToTop = function() {

  let $client = window;
  let $doc = $(document);
  let $mainContainer = $doc.find('main');
  let $buttonToTop = $doc.find('.nav-top');

  let clientHeight = $client.innerHeight;
  let mainContainerHeight = $mainContainer.innerHeight();

  let isScreenBiggerThanContent = clientHeight > mainContainerHeight;
  let isButtonTopAvailable = $buttonToTop.length > 0;

  if( !isScreenBiggerThanContent && isButtonTopAvailable ) {
    $buttonToTop.css('display', 'block');
  } else {
    $buttonToTop.css('display', 'none');
  }
};

$(window).on('turbo:load', NavigateToTop);
$(window).on('turbo:load resize scroll click', ShowNavToTop);